export default import.meta.ROLLDOWN_FILE_URL_WbWyVRFXYDxxyk7P4_8SHQ